import {
  Box, Grid, makeStyles, Typography, Hidden,
} from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import StoryContext from '../../contexts/StoryContext';
import states from '../../modules/states';
import QuestionHeaderBox from '../QuestionHeaderBox';

function Q1Header() {
  const { stateCode } = useParams();
  const { primaryColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    root: {
      marginTop: theme.spacing(2),
    },
    question: {
      marginTop: theme.spacing(2),
      color: primaryColor,
    },
    definitionBox: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      backgroundColor: `${primaryColor} !important`,
      color: '#fff !important',
    },
    questionBox: {
      padding: theme.spacing(2),
      textAlign: 'center',
    },
    headline: {
      fontWeight: 'bold',
    },
  }))();

  return (
    <Grid
      container
      className={classes.root}
      direction="row"
      justify="center"
      alignItems="center"
      spacing={4}
    >
      <Grid item xs={12}>
        <QuestionHeaderBox color={primaryColor}>
          <Typography variant="h3" component="h2" align="center" className={classes.question} gutterBottom>
            In {states[stateCode.toUpperCase()]}, are children at risk of lead exposure at home?
          </Typography>
          {/* <HelpIcon style={{ color: primaryColor, fontSize: 60 }} align="center" /> */}
          <Hidden only="xs">
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >

              <Grid item xs={3}>
                <Box borderRadius={8} className={classes.definitionBox}>
                  <Typography variant="h5" align="center">Risk of exposure</Typography>
                  <WarningIcon style={{ fontSize: 40, color: '#fff' }} />
                </Box>
              </Grid>
              <Grid item xs={1}>
                <Typography variant="body1" align="center" style={{ color: primaryColor, fontSize: 60 }}>=</Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body1" align="center">% older homes</Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography variant="body1" align="center" style={{ color: primaryColor, fontSize: 60 }}>=</Typography>
              </Grid>
              <Grid item xs={3}>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography variant="body1" align="center" style={{ marginTop: '-5px' }}># homes built before 1979</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <hr style={{ border: `2px solid ${primaryColor}` }} />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" align="center">all homes</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Hidden>
          <Hidden smUp>
            <Typography variant="body1" align="center" style={{ color: primaryColor }}>
              The risk of exposure can be understood by looking at the number of homes built before 1979 as a percentage of all homes.
            </Typography>
          </Hidden>
          <Typography variant="body1" align="center" style={{ marginTop: 10 }} gutterBottom>
            Young children can also be exposed to lead at home. Dust from lead-based paint is one of the most common causes of lead poisoning. Children have a greater risk of exposure if they live in a home built before 1979, when lead-based paint was banned.
          </Typography>
          <Typography variant="body1" align="center" style={{ marginTop: 10 }} gutterBottom>
            The only way to know if a child has been exposed to lead is to have the child&apos;s blood tested. There is no safe blood lead level in children. Even low levels can affect IQ, the ability to pay attention and academic achievement. Some child care providers ask parents to provide proof of regular blood lead level testing as part of their child’s medical record file.
          </Typography>

        </QuestionHeaderBox>
      </Grid>
    </Grid>
  );
}

export default Q1Header;
